import { createReducer, on } from '@ngrx/store';
import { MENU_COMEDOR_SEDE, MenuComedorSedeRecord } from 'src/common/menuComedor';
import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { menuComedorCancelled, menuComedorLoaded, menuComedorRequested, menuComedorSedeChanged } from './menu-comedor.actions';

export interface MenuComedorState extends EntityState<MenuComedorSedeRecord> {
	onInit: boolean,
	ready: boolean,
	sedeSelected: string
}

export const menuComedorAdapter: EntityAdapter<MenuComedorSedeRecord> = createEntityAdapter({
	selectId: (menu: MenuComedorSedeRecord) => menu.sede
})

const initialMenuState: MenuComedorState = menuComedorAdapter.getInitialState({
	onInit: true,
	ready: true,
	sedeSelected: null
});

export const menuComedorReducer = createReducer(
	initialMenuState,
	on( menuComedorRequested, ( state ) => ({ ...state, ready: false }) ),
	on( menuComedorLoaded, ( state, { menus, sedesWithoutMenu } ) => {
		if( menus?.length > 0 )
			state = menuComedorAdapter.upsertMany( menus, state );
		if( sedesWithoutMenu?.length > 0 ) 
			state = menuComedorAdapter.removeMany( sedesWithoutMenu.map( sedeEnum => MENU_COMEDOR_SEDE[ sedeEnum ] ), state );
		return { ...state, onInit: false, ready: true };
	}),
	on( menuComedorCancelled, ( state, { clear } ) => {
		if( clear === true )
			state = menuComedorAdapter.removeAll( state );
		else if( clear?.length > 0 )
			state = menuComedorAdapter.removeMany( clear.map( sedeEnum => MENU_COMEDOR_SEDE[ sedeEnum ] ), state );
		return { ...state, onInit: false, ready: true };
	}),
	on( menuComedorSedeChanged, ( state, { sedeSelected } ) => ( { ...state, sedeSelected: MENU_COMEDOR_SEDE[ sedeSelected ] } ) )
)

export const {
	selectAll,
	selectEntities,
	selectIds,
	selectTotal
} = menuComedorAdapter.getSelectors();